import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import { store } from './store';
import { ProviderContextProvider } from './components/ProviderContext';

// Get the element where you want to mount your React application
const container = document.getElementById('root');

// Check if the container is not null
if (container) {
  // Create a root
  const root = createRoot(container);
  
  // Initial render: Render the App component to the DOM
  root.render(
    <React.StrictMode>
      <ProviderContextProvider>
      <Provider store={store}>
        <App />
      </Provider>
      </ProviderContextProvider>
    </React.StrictMode>
  );
}
